<cc-list-header-edit
  [index]="index"
  [isLast]="isLast"
  [property]="property"
  (onPropertyMoved)="this.onPropertyMoved.emit($event)"
  (onRequestAddProperty)="this.onRequestAddProperty.emit($event)"
  [editable]="editable"
  [isUpgradeModalVisible]="isUpgradeModalVisible"
  [hasReachedPlanLimit]="hasReachedPlanLimit"
  (setName)="onPropertyChanged({ name: $event.name })"
  (onPropertyDeleted)="onPropertyDeleted()"
  class="sm-flex sm-justify-between"
>
</cc-list-header-edit>
